Modernizr.addTest('ipad', function () {
  return !!navigator.userAgent.match(/iPad/i);
});

Modernizr.addTest('iphone', function () {
  return !!navigator.userAgent.match(/iPhone/i);
});

Modernizr.addTest('ipod', function () {
  return !!navigator.userAgent.match(/iPod/i);
});

Modernizr.addTest('android', function () {
  return !!navigator.userAgent.match(/android/i);
});

Modernizr.addTest('mac', function () {
  return !!navigator.userAgent.match(/Mac/i);
});

Modernizr.addTest('appleios', function () {
  return (Modernizr.ipad || Modernizr.ipod || Modernizr.iphone);
});

var ie = (function () {
  var rv = null; // Return value assumes failure.
  var ua = window.navigator.userAgent;
  var msie = ua.indexOf('MSIE ');
  var trident = ua.indexOf('Trident/');

  if (msie > 0) {
    // IE 10 or older => return version number
    rv = parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  } else if (trident > 0) {
    // IE 11 (or newer) => return version number
    var rvNum = ua.indexOf('rv:');
    rv = parseInt(ua.substring(rvNum + 3, ua.indexOf('.', rvNum)), 10);
  }

  return rv;
}());

Modernizr.addTest('ie', function () {
  return !!ie;
});

Modernizr.addTest('ie8', function () {
  return (Modernizr.ie && ie === 8);
});

Modernizr.addTest('ie9', function () {
  return (Modernizr.ie && ie === 9);
});

Modernizr.addTest('ie10', function () {
  return (Modernizr.ie && ie === 10);
});

Modernizr.addTest('ie11', function () {
  return (Modernizr.ie && ie === 11);
});

var isObjectFitSupported = (function () {
  var isSupported = true;
  if ('objectFit' in document.documentElement.style === false) {
    isSupported = false;
  }
  return isSupported;
}());

Modernizr.addTest('objectfit', function () {
  return !!isObjectFitSupported;
});

Modernizr.addTest('chrome', function () {
  return !!navigator.userAgent.match(/chrome/i);
});

Modernizr.addTest('firefox', function () {
  return !!navigator.userAgent.match(/Firefox/i);
});


(function (Modernizr) {

  // Here are all the values we will test. If you want to use just one or two,
  // comment out the lines of test you don't need.
  var tests = [
    // False positive in IE, supports
    // SVG clip-path, but not on HTML element
    { name: 'svg', value: 'url(#test)' },
    { name: 'inset', value: 'inset(10px 20px 30px 40px)' },
    { name: 'circle', value: 'circle(60px at center)' },
    { name: 'ellipse', value: 'ellipse(50% 50% at 50% 50%)' },
    { name: 'polygon', value: 'polygon(50% 0%, 0% 100%, 100% 100%)' },
  ];

  var t = 0;
  var name; var value; var
    prop;

  for (; t < tests.length; t++) {
    name = tests[t].name;
    value = tests[t].value;
    Modernizr.addTest('cssclippath' + name, function () {
      // Try using window.CSS.supports
      if ('CSS' in window && 'supports' in window.CSS) {
        for (var i = 0; i < Modernizr._prefixes.length; i++) {
          prop = Modernizr._prefixes[i] + 'clip-path';

          if (window.CSS.supports(prop, value)) { return true; }
        }
        return false;
      }
      // Otherwise, use Modernizr.testStyles and examine the property manually
      return Modernizr.testStyles('#modernizr { ' + Modernizr._prefixes
        .join('clip-path:' + value + '; ') + ' }', function (elem) {
        var style = getComputedStyle(elem);
        var clip = style.clipPath;

        if (!clip || clip === 'none') {
          clip = false;

          for (var j = 0; j < Modernizr._domPrefixes.length; j++) {
            var test = Modernizr._domPrefixes[j] + 'ClipPath';
            if (style[test] && style[test] !== 'none') {
              clip = true;
              break;
            }
          }
        }

        return Modernizr.testProp('clipPath') && clip;
      });
    });

  }

}(Modernizr));
